import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { Player } from '../chess/player';
import { LiChessPlayer } from "./li-chess-player";

const profileUrl: string = 'https://lichess.org/api/user/ruttuvaari';

@Injectable()
export class LiChessService {

  constructor(private http: Http) { }

  getProfile(id: string): Promise<LiChessPlayer> {
    console.log(`in getProfile for id ${id}`);
    return this.http.get(profileUrl)
      .toPromise()
      .then((response) => {
        return response.json() as LiChessPlayer;
      })
      .catch(this.handleError);
  }

  handleError(error: any): Promise<any> {
    console.error(`An error occurred getting ${profileUrl}: ${error}`);
    return Promise.reject(error.message||error);
  }
}



// WEBPACK FOOTER //
// /workspace/chess.arska.org/chess/src/app/profile/li-chess.service.ts